/*
 * Translations (P12). Public API: import from '@/i18n'. Conventions: docs/CONVENTIONS.md §12.
 *
 *   const t = useT(ns.shell);            // a shared namespace
 *   const t = useT(messages);            // a feature's own namespace (src/features/<feature>/i18n)
 *   translate(ns.errors, 'network');     // non-React code, current language
 */
import { common } from './common';
import { components } from './components';
import { errors } from './errors';
import { format } from './format';
import { labels } from './labels';
import { payment } from './payment';
import { shell } from './shell';

export {
  defineNamespace,
  getT,
  liveT,
  messageMap,
  translate,
  translation,
  zodMessage,
  type Catalogue,
  type Key,
  type KeyOf,
  type PlainKeyOf,
  type Message,
  type Namespace,
  type Params,
  type PluralMessage,
  type Translate,
} from './core';
export {
  applyDocumentLang,
  coerceLocale,
  DEFAULT_LOCALE,
  getLocale,
  LANGUAGE_NAMES,
  LOCALES,
  setLocale,
  setPageLocale,
  subscribeLocale,
  useLocale,
  type Locale,
} from './locale';
export { useT } from './useT';

/** The shared namespaces. */
export const ns = { common, components, errors, format, labels, payment, shell } as const;
